export const msgError = {
  price_review_level_name: { required: 'Tên mức duyệt là bắt buộc' },
  model_error: ['Bạn có thật sự muốn xóa?', 'Bạn sẽ mất dữ liệu này và các dữ liệu liên quan.'],
};
